import React from 'react';
import { TileLayer } from 'react-leaflet';
import { stringify as buildQuery } from 'querystring';

// This token is public
const token = 'pk.eyJ1IjoicXVlby1jciIsImEiOiJja2p1Y25udHkzMG41MnRtanYybDBtbWc4In0.UuQkPMq-u8Bn2tqlcZLLLA';

export const geoCode = async (place, options = {}) => (await fetch(
    `https://api.tiles.mapbox.com/v4/geocode/mapbox.places/${encodeURIComponent(place)}.json?` + buildQuery({
        'access_token': token,
        'proximity': '51.0508512,13.7370518',
        'country': 'de',
        'language': 'de',
        ...options,
    }),
    {
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
    },
)).json();

export const MapboxTileLayer = () =>
    (
        <TileLayer
            url={'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=' + token}
            // Leaflet link is integrated and can't be set as target="_blank"
            attribution='© <a target="_blank" href="https://www.mapbox.com/feedback/\">Mapbox</a> © <a target="_blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
    );
